import { StyledPrimaryUserAvatar } from "shared/styled/Global"
import { useTheme } from "@mui/material/styles"

export function stringAvatar(name) {
  var names = name.split(" "),
    initials = names[0].substring(0, 1).toUpperCase()

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase()
  }
  return {
    children: `${initials}`
  }
}

const GetSize = (size, theme) => {
  switch (size) {
    case "xs":
      return {
        width: 12,
        height: 12,
        padding: "12px",
        fontSize: theme.typography.bodyXsmall.fontSize,
        fontWeight: 600
      }
    case "sm":
      return {
        width: 15,
        height: 15,
        padding: "15px",
        fontSize: theme.typography.bodySmall.fontSize,
        fontWeight: 600
      }
    default:
      return {
        width: 20,
        height: 20,
        padding: "20px",
        fontSize: theme.typography.bodyLarge.fontSize,
        fontWeight: 600
      }
  }
}

const UserAvatar = (props) => {
  const theme = useTheme()
  const { label, size } = props

  return <StyledPrimaryUserAvatar {...props} sx={GetSize(size, theme)} {...stringAvatar(label)} />
}
export default UserAvatar
